import { render, staticRenderFns } from "./OrderListPayNew.vue?vue&type=template&id=0bd87264&scoped=true"
import script from "./OrderListPayNew.vue?vue&type=script&lang=js"
export * from "./OrderListPayNew.vue?vue&type=script&lang=js"
import style0 from "./OrderListPayNew.vue?vue&type=style&index=0&id=0bd87264&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd87264",
  null
  
)

export default component.exports